import { API_TAGS } from '@/shared/api/api-tags';
import { baseApi } from '@/shared/api/base-api';
import { normalizePro20Response } from '@/shared/api/pro20-transform';

import type {
  PageMessageDeliveryEvent,
  ResubmitMessageDeliveryEventParams,
  SearchMessageDeliveryEventsParams,
} from '../types/message-delivery-event.types';

const EMPTY_PAGE: PageMessageDeliveryEvent = {
  content: [],
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  size: 0,
  number: 0,
  first: true,
  last: true,
  empty: true,
};

export const messageDeliveryEventsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchMessageDeliveryEvents: builder.query<
      PageMessageDeliveryEvent,
      SearchMessageDeliveryEventsParams
    >({
      query: ({
        branchCode,
        status,
        channel,
        source,
        referenceCode,
        page,
        size,
      }) => ({
        url: '/message-delivery-events',
        method: 'GET',
        params: {
          branchCode: branchCode || undefined,
          status: status || undefined,
          channel: channel || undefined,
          source: source || undefined,
          referenceCode: referenceCode || undefined,
          page: page ?? 0,
          size: size ?? 20,
        },
      }),
      transformResponse: (response: unknown) => {
        const result = normalizePro20Response<PageMessageDeliveryEvent>(
          response as never,
        );
        return Array.isArray(result.content) ? result : EMPTY_PAGE;
      },
      providesTags: [{ type: API_TAGS.MessageDeliveryEvents, id: 'LIST' }],
    }),
    resubmitMessageDeliveryEvent: builder.mutation<
      null,
      ResubmitMessageDeliveryEventParams
    >({
      query: ({ source, eventCode }) => ({
        url: `/message-delivery-events/${encodeURIComponent(source)}/${encodeURIComponent(eventCode)}/resubmit`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: API_TAGS.MessageDeliveryEvents, id: 'LIST' }],
    }),
  }),
});

export const {
  useSearchMessageDeliveryEventsQuery,
  useResubmitMessageDeliveryEventMutation,
} = messageDeliveryEventsApi;
